import { render, staticRenderFns } from "./ReceivablesDetailDialog.vue?vue&type=template&id=20f77f1d&scoped=true"
import script from "./ReceivablesDetailDialog.vue?vue&type=script&lang=js"
export * from "./ReceivablesDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./ReceivablesDetailDialog.vue?vue&type=style&index=0&id=20f77f1d&lang=less&scoped=true"
import style1 from "./ReceivablesDetailDialog.vue?vue&type=style&index=1&id=20f77f1d&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f77f1d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20f77f1d')) {
      api.createRecord('20f77f1d', component.options)
    } else {
      api.reload('20f77f1d', component.options)
    }
    module.hot.accept("./ReceivablesDetailDialog.vue?vue&type=template&id=20f77f1d&scoped=true", function () {
      api.rerender('20f77f1d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/const/components/ReceivablesDetailDialog.vue"
export default component.exports